import { useEffect } from 'react';

const EMAIL = 'nelitojr55@gmail.com';
const GITHUB_URL = 'https://github.com/nelitow';
const LINKEDIN_URL = 'https://www.linkedin.com/in/nelito-jr-76b349240/';
const SECTIONS = [
  'overview',
  'about',
  'experience',
  'skills',
  'education',
  'activity',
  'contact',
];

function getModelContext() {
  if (typeof navigator === 'undefined') return null;
  return navigator.modelContext || navigator.modelContextTesting || null;
}

/**
 * Registers in-page tools for browsers that implement the WebMCP API.
 * Safe no-op when the API is unavailable.
 */
export default function WebMcpTools() {
  useEffect(() => {
    const ctx = getModelContext();
    if (!ctx || typeof ctx.registerTool !== 'function') return undefined;

    const controller = new AbortController();
    const { signal } = controller;

    const tools = [
      {
        name: 'navigate_section',
        description: 'Scroll the NLTW portfolio to a named section.',
        inputSchema: {
          type: 'object',
          properties: {
            section: {
              type: 'string',
              enum: SECTIONS,
              description: 'Section id to bring into view.',
            },
          },
          required: ['section'],
          additionalProperties: false,
        },
        execute: async ({ section }) => {
          const el = document.getElementById(section);
          if (!el) {
            return { content: [{ type: 'text', text: `Section not found: ${section}` }] };
          }
          el.scrollIntoView({ behavior: 'smooth' });
          return {
            content: [{ type: 'text', text: `Navigated to #${section}` }],
          };
        },
      },
      {
        name: 'get_contact_info',
        description: 'Return email and social profile URLs for Nelito Junior.',
        inputSchema: {
          type: 'object',
          properties: {},
          additionalProperties: false,
        },
        execute: async () => ({
          content: [
            {
              type: 'text',
              text: JSON.stringify(
                {
                  email: EMAIL,
                  github: GITHUB_URL,
                  linkedin: LINKEDIN_URL,
                  site: 'https://www.nltw.xyz',
                },
                null,
                2
              ),
            },
          ],
        }),
      },
      {
        name: 'open_external_link',
        description: 'Open GitHub or LinkedIn for Nelito Junior in a new tab.',
        inputSchema: {
          type: 'object',
          properties: {
            target: {
              type: 'string',
              enum: ['github', 'linkedin', 'email'],
              description: 'Which channel to open.',
            },
          },
          required: ['target'],
          additionalProperties: false,
        },
        execute: async ({ target }) => {
          if (target === 'email') {
            window.location.href = `mailto:${EMAIL}`;
            return { content: [{ type: 'text', text: `Opened mailto:${EMAIL}` }] };
          }
          const url = target === 'github' ? GITHUB_URL : LINKEDIN_URL;
          window.open(url, '_blank', 'noopener');
          return { content: [{ type: 'text', text: `Opened ${url}` }] };
        },
      },
    ];

    tools.forEach(tool => {
      try {
        ctx.registerTool(tool, { signal });
      } catch {
        // Older experimental shapes used provideContext({ tools }).
        try {
          if (typeof ctx.provideContext === 'function') {
            ctx.provideContext({ tools: [tool] });
          }
        } catch {
          /* ignore unsupported WebMCP shapes */
        }
      }
    });

    return () => controller.abort();
  }, []);

  return null;
}
